import { render, staticRenderFns } from "./OverviewBuyCards.vue?vue&type=template&id=2bd2f5f6&scoped=true&"
import script from "./OverviewBuyCards.vue?vue&type=script&lang=js&"
export * from "./OverviewBuyCards.vue?vue&type=script&lang=js&"
import style0 from "./OverviewBuyCards.vue?vue&type=style&index=0&id=2bd2f5f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2f5f6",
  null
  
)

export default component.exports